// Configuration
export const COMPANY_BRAND_NAME = 'Suitcase Muse';
export const COMPANY_LEGAL_NAME = 'MUSE GLOBALTECH VENTURES PRIVATE LIMITED';

export const WHATSAPP_NUMBER = "+918826167100"; // Actual WhatsApp Business number

// WhatsApp message templates
export const WHATSAPP_MESSAGES = {
  base: "Hi! I'm interested in Suitcase Muse.",
  consultation: "I'd like to schedule a styling consultation.",
  aiStyling: "I'm interested in AI Styling.",
  expertBasic: "I'm interested in Expert Styling (Basic).",
  expertPremium: "I'm interested in Expert Styling (Premium)."
};
